import { render } from "./OverlayModal.vue?vue&type=template&id=39a8f80e&scoped=true"
import script from "./OverlayModal.vue?vue&type=script&lang=js"
export * from "./OverlayModal.vue?vue&type=script&lang=js"

import "./OverlayModal.vue?vue&type=style&index=0&id=39a8f80e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a8f80e"]])

export default __exports__